import { uniqueId } from "lodash";

export const getImageUrl = (documentURL) =>
  `${process.env.REACT_APP_DOCUMENT_URL}/${encodeURIComponent(
    documentURL
  )}?${uniqueId("doc_")}`;
